import * as Linking from "expo-linking";

const permissionsConfig = {
  initialRouteName: "CameraPermissionScreen",
  screens: {
    CameraPermissionScreen: "camera",
  },
};

export const linking = {
  prefixes: [Linking.createURL("/")],
  config: {
    screens: {
      LogInScreen: "login",
      EurekaOAuthCallbackScreen: "auth/callback/eureka",
      RootStack: {
        screens: {
          PhotoImageRootScreen: {
            initialRouteName: "SelectProductForUtilityScreen",
            path: "/",
            screens: {
              SelectProductForUtilityScreen: "products",
              ProductImageDetailsRootScreen: {
                path: "products/:productId",
                screens: {
                  ProductImageDetailsScreen: "edit",
                  SelectUploadImageMethodScreen: "upload",
                  PermissionsModalRootScreen: permissionsConfig,
                },
              },
              ImagesSentSuccessPartialScreen: {},
              SelectUploadRetailerImageMethodScreen: "products/upload-retailer",
              ProductImageDeleteScreen: {},
              ImagesSentSuccessScreen: {},
              PermissionsModalRootScreen: permissionsConfig,
              BarcodeScannerRootScreen: {
                path: "scanner",
                initialRouteName: "BarcodeScannerScreen",
                screens: {
                  BarcodeScannerScreen: "/",
                  BarcodeSettingsScreen: "settings",
                  ScanAgainScreen: {},
                  ProductScannedPartialScreen: {},
                  RetailerOnlyScannedPartialScreen: {},
                },
              },
            },
          },
        },
      },
    },
  },
};
